import { Component } from '@angular/core';

import { AuthenticationService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'TecAlliance SSO Audience Store';

  constructor(private service: AuthenticationService) {
  }

  loggedIn(): boolean {
    return this.service.userLoggedIn();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts